/** User-facing product name for Malloy-backed semantic analytics (APIs still use malloy_*). */
export const ROSETTA_DISPLAY_NAME = 'Rosetta';

/** Replace legacy "Malloy" wording in labels returned by the API or seeds. */
export function rosettaDisplayLabel(text: string): string {
  return text.replace(/\bMalloy\b/g, ROSETTA_DISPLAY_NAME);
}
